var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fad fa-user-clock",staticStyle:{"color":"mediumpurple","--fa-secondary-color":"thistle","--fa-secondary-opacity":"1.0"}})}
var staticRenderFns = []

export { render, staticRenderFns }